import {
    APIResponse,
    StoreListResponse,
    StoreDetailResponse,
    CreateStoreRequest,
    CreateStoreResponse,
    UpdateStoreRequest,
    UpdateStoreResponse,
    StoreListRequestParams,
} from '../types';
import httpService from './httpService';

export function fetchStoreListAPI(
    params: StoreListRequestParams,
    options?: { signal?: AbortSignal },
): APIResponse<StoreListResponse> {
    return httpService.get('/store', { params, signal: options?.signal });
}

export function fetchStoreDetailAPI(
    storeId: number,
    options?: { signal?: AbortSignal },
): APIResponse<StoreDetailResponse> {
    return httpService.get(`/store/${storeId}`, { signal: options?.signal });
}

export function createStoreAPI(data: CreateStoreRequest): APIResponse<CreateStoreResponse> {
    return httpService.post('/store', data);
}

export function updateStoreAPI(storeId: string, data: UpdateStoreRequest): APIResponse<UpdateStoreResponse> {
    return httpService.put(`/store/${storeId}`, data);
}

export function deleteStoreAPI(storeId: string): APIResponse<object> {
    return httpService.delete(`/store/${storeId}`);
}
